/**
 * ScrollToTop class.
 * @extends HTMLElement
 */
if (!customElements.get('scroll-to-top')) {
  customElements.define(
    'scroll-to-top',
    class ScrollToTop extends HTMLElement {
      constructor() {
        super();
        // Bind the event handler to preserve 'this' context
        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
      }

      /**
       * Invoked each time the custom element is appended into a document-connected element.
       */
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.target = this.closest('product-list') || this.closest('main') || this.closest('body');
        if (!this.target) return;

        // Listen for click events on the button
        this.button.addEventListener('click', this.handleClick);

        // Listen for scroll events on the window
        window.addEventListener('scroll', this.handleScroll);

        // Trigger once on mount to set initial styles based on current scroll position
        this.handleScroll();

        // Remove hidden attribute
        this.removeAttribute('hidden');
      }

      /**
       * Invoked each time the custom element is disconnected from the document's DOM.
       */
      disconnectedCallback() {
        // Clean up the listeners to prevent memory leaks
        this.button.removeEventListener('click', this.handleClick);
        window.removeEventListener('scroll', this.handleScroll);
      }

      /**
       * Calculates scroll position and toggles inline styles.
       */
      handleScroll() {
        const scrollY = window.scrollY || window.pageYOffset;

        // Apply styles if the page is scrollable and user has scrolled past halfway
        this.classList.toggle('is-visible', scrollY > 0 && scrollY >= 500);
      }

      /**
       * Handles the scroll to top.
       */
      handleClick() {
        this.target.scrollIntoView({ behavior: 'smooth' });
      }
    },
  );
}
